export default {
  zh: {
    changePassword: '修改密码',
    setNewPassword: '设置新密码',
    oldPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    sureCommit: '确认修改',
    networkError: '网络错误，请稍后再试',
    modifyPasswordSuccess: '密码修改成功'
  },
  en: {
    changePassword: 'Change Password',
    setNewPassword: 'Set New Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    sureCommit: 'Update Password',
    networkError: 'Network error, please try again later',
    modifyPasswordSuccess: 'Success'
  }
}



// WEBPACK FOOTER //
// ./src/views/safecenter/lang.js